module.exports = __webpack_public_path__ + "img/inoo3.8fbf4a9e.jpg";